export const CRUCIGRAMA_SOUNDS = {
    GOOD_ACTIVE: "goodActive",
    MOVE: "move",
    WRITE: "write",
    CORRECT: "correct"
}